module.exports = __webpack_public_path__ + "img/plus-circle.6ac1dd47.svg";